import { z } from "zod";
import type {
    DurationInDays,
    DurationInHours,
    DurationInMinutes} from "../date-time/time-spans";
import {
    durationInDaysZodSchema,
    durationInHoursZodSchema,
    durationInMinutesZodSchema,
} from "../date-time/time-spans";

type DurationBaseLength = DurationInDays | DurationInHours | DurationInMinutes;

const durationBaseLengthZodSchema: z.ZodSchema<DurationBaseLength> = z.union([
    durationInDaysZodSchema,
    durationInHoursZodSchema,
    durationInMinutesZodSchema,
]);

export type { DurationBaseLength };
export { durationBaseLengthZodSchema };
